/**
 * works with TicketGroupTable.tsx
 */

/**
 * show the back to top button
 * @param event
 */
const isPassedTop = (event: React.ChangeEvent) => {
  const scrollTop = event.target.scrollTop;
  return scrollTop > 10;
};

/**
 * trigger load
 * @param event
 */
const isAtBottom = (event: React.ChangeEvent) => {
  const toCheck = event.target.scrollHeight - event.target.scrollTop;
  const rangeToCheck = 3;
  const minClient = event.target.clientHeight - rangeToCheck;
  const maxClient = event.target.clientHeight + rangeToCheck;
  const bottom = toCheck >= minClient && toCheck <= maxClient;
  return bottom;
};

export const WorkdeskScrollHelper = {
  isPassedTop,
  isAtBottom,
};
